// removed by extract-text-webpack-plugin
module.exports = {"removePadding":"SearchUser__removePadding___18UN1","buttonContainer":"SearchUser__buttonContainer___1vTD5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchUser/SearchUser.scss
// module id = 1529
// module chunks = 0